// Archivo: ImportResult.jsx

import React from "react";
import { Box, Paper, Alert, Stack, List, ListItem, ListItemText } from "@mui/material";
import RevaText from "components/common/RevaText";

const ImportResult = ({ summary }) => {
  const { message, totalProcessed, totalImported, totalSkipped, skippedList } = summary;

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <RevaText variant="h6" gutterBottom>
        Resultado de la importación
      </RevaText>

      <Stack spacing={1} mb={2}>
        <Alert severity="success">{message}</Alert>
        <RevaText variant="body2">👥 Total procesados: {totalProcessed}</RevaText>
        <RevaText variant="body2" color="success.main">
          ✅ Importados: {totalImported}
        </RevaText>
        <RevaText variant="body2" color="warning.main">
          ⚠️ Omitidos: {totalSkipped}
        </RevaText>
      </Stack>

      {skippedList.length > 0 && (
        <Box>
          <RevaText variant="body2" sx={{ fontWeight: 600 }}>
            Detalles de omitidos:
          </RevaText>
          <List dense sx={{ pl: 2 }}>
            {skippedList.slice(0, 5).map((item, idx) => (
              <ListItem key={idx} disableGutters>
                <ListItemText primary={`${item.name || "(sin nombre)"}: ${item.reason || JSON.stringify(item)}`} />
              </ListItem>
            ))}
          </List>
          {skippedList.length > 5 && (
            <RevaText variant="caption">Mostrando primeros 5 de {skippedList.length} omitidos</RevaText>
          )}
        </Box>
      )}
    </Paper>
  );
};

export default ImportResult;
